import React, { Component } from 'react';
import '../../../web/index.css';
import ContainerClass from './drag_container';


class CalenderCard extends Component {
    render() {
        return (
            <div className="sched-months-grid">
                {this.props.PeriodicData.map(x => {
                    const shortName = x.name ? x.name.slice(0, 3) : '';
                    const displayName = shortName ? shortName + ' Data' : x.name || '';
                    return (
                        <ContainerClass
                            key={x.month}
                            id={x.month}
                            name={displayName}
                            year={x.month}
                            list={x.data}
                            month_name={x.month}
                            user_data={x.data.user_list}
                            cardClick={this.props.cardClick}
                            toggle={this.props.toggle}
                        />
                    );
                })}
            </div>
        );
    }
}

CalenderCard.defaultProps = { PeriodicData: [] };

export default CalenderCard;



// WEBPACK FOOTER //
// ./src/shared/containers/PeriodicalScheduling/calender_card.js